export default __webpack_public_path__ + "0e775b5251260720ce1235fc0b4d6138.csv";